import { useQuery } from '@tanstack/react-query';
import financialService from 'v2/services/financial';
import { useUserStore } from 'v2/store/User';

export const useBalance = () => {
  const { user } = useUserStore(({ user }) => ({ user }));

  const { data, isFetching, error, refetch } = useQuery({
    queryKey: ['financial', 'available', user.type],
    queryFn: () => financialService.listAvailable(user.type).toPromise(),
    enabled: !!user.type
  });

  return {
    data,
    isFetching,
    error,
    refetch
  };
};
